import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-4"
}
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }

import type { FishTransfer } from '@/types/v2';
import { computed } from 'vue';
import type { OperationInfo } from '@/types/v2/task/animal-transfer/operation.types';
import TransferListItem from './TransferListItem.vue';

interface Props {
    transfers: FishTransfer[];
    transferInfo?: OperationInfo;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TransferList',
  props: {
    transfers: { default: () => [] },
    transferInfo: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

const hasTransfers = computed(() => props.transfers.length > 0 && props.transferInfo);

return (_ctx: any,_cache: any) => {
  return (hasTransfers.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transfers, (transfer, index) => {
            return (_openBlock(), _createBlock(TransferListItem, {
              key: transfer.key,
              index: index,
              transfer: transfer,
              transferInfo: _ctx.transferInfo
            }, null, 8, ["index", "transfer", "transferInfo"]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})